import axios from "axios";

axios.defaults.withCredentials = true;

export default {
  /**
   * Récupération de le référentiel Type Souscription
   * - renvoie un objet vide si non connecté
   */
  async getRefTypeSouscriptions() {
    const typeSouscription = await axios.get(
      process.env.VUE_APP_BACKEND_API_URL +
        process.env.VUE_APP_URL_TYPESOUSCRIPTION
    );
    return typeSouscription.data;
  },

  async getDemandes() {
    //récupérer le Userldap
    const demandes = await axios.get(
      process.env.VUE_APP_BACKEND_API_URL + process.env.VUE_APP_URL_DEMANDES
    );
    return demandes.data;
  },

  async getDemandesGestionnaire() {
    //récupérer le Userldap
    const demandes = await axios.get(
      process.env.VUE_APP_BACKEND_API_URL +
        process.env.VUE_APP_URL_DEMANDES +
        "/drh/forGestionnaire"
    );
    return demandes.data;
  },

  async getDemandesGestionnaireByUid(uid) {
    //console.log("getDemandes");
    //récupérer le Userldap
    const demandes = await axios.get(
      process.env.VUE_APP_BACKEND_API_URL +
        process.env.VUE_APP_URL_DEMANDES +
        "/drh/forGestionnaire/" +
        uid
    );
    //console.log(demandes.data);
    return demandes.data;
  },

  async saveDemande(formComplementaire) {
    var dataFile = new FormData();
    dataFile.append(
      "df",
      formComplementaire.nameFile,
      formComplementaire.nameFile.name
    );
    var exportFormComplementaireString = JSON.stringify(formComplementaire);
    var exportFormComplementaire = JSON.parse(exportFormComplementaireString);
    exportFormComplementaire.nameFile = formComplementaire.nameFile.name;
    dataFile.append("fc", JSON.stringify(exportFormComplementaire));
    const demande = await axios.post(
      process.env.VUE_APP_BACKEND_API_URL + process.env.VUE_APP_URL_DEMANDES,
      dataFile,
      {
        "content-type": "multipart/form-data",
      }
    );
    return demande.data;
  },

  async updateDemande(formComplementaire) {
    //console.log(JSON.stringify(formComplementaire));
    const demande = await axios.put(
      process.env.VUE_APP_BACKEND_API_URL +
        process.env.VUE_APP_URL_DEMANDES +
        "/drh",
      formComplementaire,
      {
        "content-type": "application/json",
      }
    );
    return demande.data;
  },

  async getDemandeFileDRH(idFile) {
    return (
      process.env.VUE_APP_BACKEND_API_URL +
      process.env.VUE_APP_URL_FILE_FORM_COMP_DRH +
      idFile
    );
  },

  async getDemandeFile64DRH(idFile) {
    const demandes = await axios.get(
      process.env.VUE_APP_BACKEND_API_URL +
        process.env.VUE_APP_URL_FILE_FORM_COMP_64_DRH +
        idFile
    );
    return demandes.data;
  },

  async getDemandeFileAgent(idFile) {
    return (
      process.env.VUE_APP_BACKEND_API_URL +
      process.env.VUE_APP_URL_FILE_FORM_COMP_AGENT +
      idFile
    );
  },

  async getByLot(id) {
    return (
      await axios.get(
        process.env.VUE_APP_BACKEND_API_URL +
          process.env.VUE_APP_URL_DEMANDES +
          "/consultation/" +
          id
      )
    ).data;
  },
};
